import { useEffect, useState } from 'react'
import { apiGet } from '../lib/api'

/** Probes tag-keys API; 404 means feature flag is off for this tenant. */
export function useResourceGroupsEnabled(tenantId: string) {
  const [enabled, setEnabled] = useState(false)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    if (!tenantId) {
      setEnabled(false)
      setLoading(false)
      return
    }
    setLoading(true)
    apiGet<unknown[]>(`/api/v1/tenants/${tenantId}/tag-keys`)
      .then(() => setEnabled(true))
      .catch(() => setEnabled(false))
      .finally(() => setLoading(false))
  }, [tenantId])

  return { enabled, loading }
}
